<template>
  <div class="partMeeting-container">
    <van-sticky>
      <head-bar
          type="primary"
          :leftArrow="true"
          left-text=""
          title="大屏直播地址"
          @onClickLeft="onClickLeft"
      />
    </van-sticky>
    <div class="main">
      <!-- 直播信息卡片 -->
      <div class="live-info-card">
        <div class="live-title">开幕式|岳麓论坛大屏直播</div>
        <div class="live-details">
          <div class="detail-item">
            <van-icon name="clock-o" />
            <span>时间：2025年9月15日 09:00-11:30</span>
          </div>
<!--          <div class="detail-item">-->
<!--            <van-icon name="location-o" />-->
<!--            <span>地点：国家网络安全产业园</span>-->
<!--          </div>-->
          <div class="detail-item">
            <van-icon name="info-o" />
            <span>提示：请准时前往观看大屏直播</span>
          </div>
        </div>
      </div>

      <!-- 会场详情 -->
      <div class="venue-detail">
        <div class="venue-map">
          <img src="https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202509121508533436912.jpeg"
               alt="会场地图"
               class="map-image">
        </div>

        <div class="venue-info">
          <h3 class="info-title">国家网络安全产业园</h3>
          <div class="info-item">
            <van-icon name="map-marked" color="#1976D2" />
            <span>详细地址：国家网络安全产业园1A栋4楼</span>
          </div>
          <van-button
              type="primary"
              size="large"
              class="nav-button"
              @click="onGoLocation">
            <van-icon name="location-o" /> 导航前往
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headBar from "@/components/headBar/headBar";
import { Toast } from "vant";
import wx from '@/utils/wx'

export default {
  components: { headBar },
  data() {
    return {
      venue: {
        label: '国家网络安全产业园',
        lng: '112.883094',
        lat: '28.231622',
        address: '国家网络安全产业园',
        place: '国家网络安全产业园'
      }
    };
  },
  mounted() {
    this.getLiveList();
  },
  methods: {
    onGoLocation() {
      wx.openLocation(
          Number(this.venue.lat),
          Number(this.venue.lng),
          this.venue.place,
          this.venue.place
      )
    },
    onClickLeft() {
      this.$router.push("/user/" + this.$store.state.miceInfo.miceLink);
    },
    async getLiveList() {
      try {
        let result = await this.$http.get(
            this.$baseURL.index.getGroupList() + "?miceLink=" + this.$store.state.miceInfo.miceLink,
            1
        );
        console.log(result.data);
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.partMeeting-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  //background-color: #f5f7fa;
  background: url("https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202508281859467961563.png") no-repeat;
  background-size: cover;

  .main {
    flex: 1;
    padding: 15px;
    overflow-y: auto;

    /* 直播信息卡片样式 */
    .live-info-card {
      background-color: white;
      border-radius: 12px;
      padding: 20px;
      margin-bottom: 20px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

      .live-title {
        font-size: 18px;
        font-weight: bold;
        color: #1976D2;
        margin-bottom: 15px;
        text-align: center;
      }

      .live-details {
        .detail-item {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          font-size: 14px;
          color: #333;

          .van-icon {
            margin-right: 10px;
            color: #1976D2;
            font-size: 16px;
          }
        }
      }
    }

    /* 会场详情样式 */
    .venue-detail {
      background-color: white;
      border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

      .venue-map {
        height: 200px;
        overflow: hidden;

        .map-image {
          width: 100%;
          height: 100%;
          //object-fit: cover;
        }
      }

      .venue-info {
        padding: 20px;

        .info-title {
          font-size: 18px;
          color: #333;
          margin-bottom: 15px;
          text-align: center;
          font-weight: bold;
        }

        .info-item {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          font-size: 14px;
          color: #555;

          .van-icon {
            margin-right: 10px;
            font-size: 16px;
          }
        }

        .nav-button {
          margin-top: 25px;
          border-radius: 8px;
          font-size: 16px;
          height: 46px;
          line-height: 46px;

          .van-icon {
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>